import { render, staticRenderFns } from "./Button-v2.vue?vue&type=template&id=3aa5416d&lang=pug"
import script from "./Button-v2.vue?vue&type=script&lang=js"
export * from "./Button-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports